const addingNewLocationKey = 'entering-new-location';
export default addingNewLocationKey;
